import React, { useEffect, useState } from "react";
import Header from "../component/sharedComponents/header";
import AskSection from "../component/home/askSection";
import FooterUser from "../component/sharedComponents/footer";
import ImportantServices from "../component/home/importantServices";
import CustomIntroSection from "../component/explainBuyPage/customIntroSection";
import { useTranslation } from "react-i18next";
import zaraSale from "../assets/images/zaraSale.png";
import { useLocation, useParams } from "react-router-dom";
import useLanguageDirection from "../hooks/useLanguageDirection";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../component/animation/LoadingSpinner";
import { fetchStoreBySlug } from "../redux/reducer/storesReducer";

const NewStores = () => {
  const { t, i18n } = useTranslation();
  const { name } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [store, setStore] = useState(location.state?.store);

  useEffect(() => {
    const loadFromSlug = async () => {
      try {
        // const slug = location.pathname.split("/").pop();
        const pathSegments = location.pathname.split("/").filter(Boolean);
        const slug_store = pathSegments[pathSegments.length - 1]; // "men"

        // console.log(slug); // ?slug=men&area=Europe
        const slug = `?slug=${slug_store}`;
        setLoading(true);

        const result = await dispatch(fetchStoreBySlug(slug));
        const Data = result.payload;
        // console.log(categoryData)
        setStore(Data); // Data
        // console.log(store)
        setLoading(false);
      } catch (error) {
        setError("Error fetching Store by slug.");
        setLoading(false);
      }
    };

    if (!store) {
      loadFromSlug();
    }
  }, [dispatch, location.state?.store, location.pathname]);

  useEffect(() => {
    if (!store) {
      console.error("No store found in state.");
    }
  }, [store]);

  const currentLang = i18n.language === "ar" ? "ar" : "en";

  const formattedDesc = store?.desc?.[currentLang]
    ?.split(/\r?\n+/)
    .filter((paragraph) => paragraph.trim() !== "")
    .map((paragraph, index) => (
      <p key={index} className="text-lg leading-relaxed">
        {paragraph}
      </p>
    ));

  const direction = useLanguageDirection();

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-xl font-semibold text-red-600">{error}</p>
      </div>
    );
  }
  if (loading) {
    return <LoadingSpinner />;
  }
  //   console.log(store)
  return (
    <div key={name}>
      <Header />
      <div className="mt-[55px] md:mt-[54px] lg:mt-[75px]">
        <CustomIntroSection title={t("importantServices.title")} />
      </div>

      <div className="max-container" dir={direction}>
        <div className="flex flex-col gap-4 mx-2 my-10 md:flex-row lg:mx-0">
          <div className="flex flex-col justify-center gap-5 text-black md:w-1/2">
            <h3 className="text-2xl font-bold">
              {store?.subTitle?.[currentLang] || ""}
            </h3>
            {formattedDesc}
          </div>
          <div className="md:w-1/2">
            <img
              src={store?.img || zaraSale}
              alt="store-promo"
              className="object-cover w-full h-full rounded-lg"
            />
          </div>
        </div>
      </div>

      <ImportantServices />
      <AskSection />
      <FooterUser />
    </div>
  );
};

export default NewStores;
